<template>
  <button v-bind="$attrs" class="iconic-button pointer" v-on="$listeners">
    <i class="material-icons iconic-button__icon">{{ icon }}</i>
    <span class="iconic-button__text">
      {{ text }}
    </span>
  </button>
</template>
<script>
export default {
  name: 'IconicButton',
  inheritAttrs: false,
  props: {
    icon: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
  },
};
</script>
<style lang="scss">
.iconic-button {
  display: flex;
  flex-direction: column;
  align-items: center;

  min-width: rem-calc(50px);

  color: $lb-dark-gray;

  padding: $global-padding / 4 $global-padding / 2;

  transition-duration: 0.3s;

  &:hover {
    background-color: $lb-light-gray;
  }

  &__text {
    margin-top: $global-margin / 4;
    font-size: $lb-small-font-size;
  }
}
</style>
